/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { select, takeEvery } from 'redux-saga/effects';

import { pluginEndpoint } from '../data/prefabs';
import { UNLOAD_PLUGIN } from '../actions';

export function* handleUnloadPlugin({ payload }) {
  const endpoint = yield select(pluginEndpoint.value);
  if (endpoint) {
    endpoint.unloadPlugin(payload);
  }
}

export default function* watchUnloadPlugin() {
  yield takeEvery(UNLOAD_PLUGIN, handleUnloadPlugin);
}
